import React from 'react';
import ReactDOM from 'react-dom';
import AppContainer from './containers/AppContainer';
import createStore from './store/createStore';
import createHistory from './store/isomorphicHistory';
import createRoutes from './routes';
const bootstrap = async () => {
  const INITIAL_URL = '';
  const MOUNT_NODE = document.getElementById('root');

  const history = createHistory(INITIAL_URL);
  const { store, persistor } = await createStore({}, history);

  store.dispatch({ type: 'CLEAN_UP_STATE' });

  const render = () => {
    const routes = createRoutes();

    ReactDOM.render(
      <AppContainer
        store={store}
        history={history}
        routes={routes}
        persistor={persistor}
      />,
      MOUNT_NODE
    );
  };

  render();
};
bootstrap();



// WEBPACK FOOTER //
// ./src/index.js